import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { newsAPI } from '../../lib/api';
import { formatDate } from '../../lib/utils';
import { Calendar, ArrowLeft } from 'lucide-react';
import { SEO } from '../seo/SEO';

export const NewsListPage = ({ siteKey }) => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadNews = async () => {
      try {
        const response = await newsAPI.getAll(siteKey);
        setNews(response.data);
      } catch (error) {
        console.error('Error loading news:', error);
      } finally {
        setLoading(false);
      }
    };
    loadNews();
  }, [siteKey]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="spinner" />
      </div>
    );
  }

  return (
    <div className="py-12">
      <SEO
        siteKey={siteKey}
        title="Aktuality"
        description={`Aktuální novinky, oznámení a informace z ${siteKey === 'ms' ? 'MŠ Cestička' : 'dětské skupiny Chaloupka na vršku'} v Nové Roli. Sledujte, co se u nás děje.`}
        keywords={['aktuality', 'novinky', 'oznámení']}
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10">
          <Link to={`/${siteKey}`} className="inline-flex items-center gap-2 text-[#64748B] hover:text-[#45AAF2] mb-4" data-testid="back-link">
            <ArrowLeft size={18} />
            Zpet na uvodní stránku
          </Link>
          <h1 className="text-4xl font-bold text-[#2D3748]" data-testid="page-title">Aktuality</h1>
          <p className="text-[#64748B] mt-2">Novinky a dulezité informace</p>
        </div>

        {news.length > 0 ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {news.map((item, index) => (
              <Link 
                key={item.id} 
                to={`/${siteKey}/aktuality/${item.id}`}
                className="news-card animate-fade-in-up"
                style={{ animationDelay: `${index * 50}ms` }}
                data-testid={`news-item-${index}`}
              >
                {item.image_url && (
                  <img src={item.image_url} alt={item.title} className="news-card-image" />
                )}
                <div className="p-6">
                  <div className="flex items-center gap-2 text-sm text-[#64748B] mb-3">
                    <Calendar size={14} />
                    {formatDate(item.created_at)}
                  </div>
                  <h2 className="font-semibold text-lg text-[#2D3748] mb-2 line-clamp-2">{item.title}</h2>
                  <p className="text-[#64748B] text-sm line-clamp-3">{item.excerpt || item.content}</p>
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <div className="text-center py-20">
            <div className="text-[#64748B]">Zatím nejsou žádné aktuality</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default NewsListPage;
